import { CookieDetailV3 } from "./types";

export const initialState: CookieDetailV3 = {
  version: 3,
  strictlyNecessary: true,
  custom: {
    performance: true,
    functionality: true,
    targeting: true,
  },
};
